import React from "react";
import { HubCardStack } from "../../components";
import { PartHistoryTable } from "../../tables";
import { Stack, Typography } from "@mui/material";

export const PartDetailsHistory = ({ id }) => {
  return (
    <HubCardStack gap="25px" margin="15px">
      <Stack>
        <Typography variant="boldCaptionMainL">Part History</Typography>
        <Typography variant="caption">
          Details recorded for the variations of part information like name,
          number, weight. Routing is not recorded here.
        </Typography>
      </Stack>
      <PartHistoryTable id={id} />
    </HubCardStack>
  );
};

export default PartDetailsHistory;
